import {axiosInstance} from "@/plugins/axios";

export interface ItemPayload {
    month: string,
    id: string,
}

export async function getFTABillOfMaterials(payload: ItemPayload) {
    let url = `fta_bill_of_materials/${payload.id}`

    if (payload.month) {
        url +=`?month=${payload.month}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
}